import { isSoftwareVersionSupported } from 'src/Libs/home-power-station'
import { PMType } from '../types'

/**
 * Check if the powermeter name can be changed by the user.
 */
export const canChangePowermeterName = (powermeterType: PMType, softwareVersion: string): boolean => {
  if (powermeterType === PMType.PM_TYPE_ROOT) return false
  if (powermeterType === PMType.PM_TYPE_ADDITIONAL) {
    return isSoftwareVersionSupported('2024.042', softwareVersion)
  }
  return true
}
